import { networkType } from "@/utils/deviceInfo";

/**
 * 跟踪字段映射配置
 */
export const TrackingFieldMap: {
  [key: string]: (
    query: Record<string, string>
  ) => Record<string, string> | string;
} = {
  ext: (query: Record<string, string>) => query || {},
  remark: () => networkType(),
  key1: (query: Record<string, string>) => query?.i || "",
  key2: (query: Record<string, string>) => query?.creator || "",
  key3: (query: Record<string, string>) => query?.channelCode || "",
  utm_campaign: (query: Record<string, string>) =>
    query?.channel_platform || "",
};

/**
 * 归因字段映射配置
 */
export const CustomerAttributionFieldMap: { [key: string]: string[] } = {
  i: ["tenjin_parameter_0", "site_id"],
  I: ["tenjin_parameter_0", "site_id"],
  channel_code: ["tenjin_parameter_1", "site_id"],
  channel_platform: ["tenjin_parameter_2"],
  channel_referrer: ["tenjin_parameter_3"],
};
